<router-outlet></router-outlet>
<a routerLink="/test" class="test-splash" *ngIf="isTest">
  {{isTest}} TEST
</a>
